import React from 'react';
import LearningCard from '../components/LearningCard';

const ScratchAndWin = () => (
  <LearningCard
    testid="scratch-and-win"
    logoSrc="/logo-25.png"
    logoAlt="25"
    title="Scratch & Win"
    subtitle="Store Briefing — Pentecost"
    support={[
      'Over the Pentecost weekend, from 23 to 25 May, the Village will run a Scratch & Win activation.',
      'Guests can unlock Scratch & Win cards by shopping in multiple boutiques and scanning their Membership code with each purchase. The first card is unlocked after shopping and scanning in 4 boutiques. Additional boutiques can unlock extra cards, up to a maximum of 5 cards per member.',
      'For stores and boutiques, the key role is simple: scan the Membership code with every purchase.',
      'Each scan supports the guest journey and helps guests unlock their Scratch & Win chances.',
      'The activation communication also highlights the same flow: shop and scan, collect Scratch & Win cards, and redeem prizes directly at the boutique if the guest wins.',
    ]}
    buttons={[
      {
        label: 'Open the microlearning',
        href: 'https://app.qoldo.com/p/e930f7a6-bdfb-465e-b651-f9929622e490?t=07dbf84a-e41d-402e-b9b6-cd7b391dd57b',
        testid: 'btn-open-microlearning',
      },
    ]}
  />
);

export default ScratchAndWin;
